<template>
  <div class="pages">
    <van-form @submit="onSubmit">
      <van-field
        v-model="currentSelectTime"
        name="所选时间段"
        label="所选时间段"
        placeholder="填写联系人"
        disabled
      />
      <van-field
        v-model="currentSelectRoom"
        name="所选会议室"
        label="所选会议室"
        placeholder=""
        disabled
      />
      <van-field
        v-model="startMeettime"
        name="会议开始时间"
        label="会议开始时间"
        placeholder="填写会议开始时间"
        @click="showStartTimes = true"
        readonly
        :rules="[{ required: true, message: '请填写会议开始时间' }]"
      />
       <van-field
        v-model="endMeettime"
        name="会议结束时间"
        label="会议结束时间"
        placeholder="填写会议结束时间"
        @click="showEndTimes = true"
        readonly
        :rules="[{ required: true, message: '请填写会议结束时间' }]"
      />
      <!-- <van-datetime-picker
  v-model="meetingTime"
  type="time"
  title="选择时间"
  :min-hour="10"
  :max-hour="20"
/> -->
      <van-field
        v-model="username"
        name="联系人"
        label="联系人"
        placeholder="填写联系人"
        :rules="[{ required: true, message: '请填写联系人' }]"
      />
      <van-field
        v-model="password"
        type="number"
        name="联系电话"
        label="联系电话"
        placeholder="联系电话"
        :rules="[{ required: true, message: '请填写联系电话' }]"
      />
      <van-field
        v-model="message"
        rows="2"
        autosize
        label="事由"
        type="textarea"
        maxlength="200"
        placeholder="请输入事由"
        show-word-limit
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
    <van-popup v-model="showStartTimes" position="bottom">
      <van-datetime-picker
        v-model="valuesss"
        type="time"
        title="选择时间"
        :min-hour="0"
        :max-hour="24"
        @confirm="confirmStartTime"
        @cancel="showStartTimes = false"
      />
    </van-popup>

    <van-popup v-model="showEndTimes" position="bottom">
      <van-datetime-picker
        v-model="valuesss"
        type="time"
        title="选择时间"
        :min-hour="0"
        :max-hour="24"
        @confirm="confirmEndTime"
        @cancel="showEndTimes = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { addAudit } from "../../apis/api";
import { Toast, Dialog } from "vant";
export default {
  data() {
    return {
      username: "",
      valuesss: "",
      showEndTimes: false,
      showStartTimes:false,
      password: "",
      message: "",
      currentSelectTime: "",
      currentSelectRoom: "",
      startMeettime: "",
      endMeettime: "",
    };
  },
  mounted() {
    document.title = "会议预约";
    this.currentSelectRoom = this.$route.query.name;
    console.log(JSON.parse(localStorage.getItem("weeks")));
    console.log(this.$route.query.index);
    let indexs = this.$route.query.index;
    let duringTime = "";
    let index;
    if (this.$route.query.index < 7) {
      index = JSON.parse(localStorage.getItem("weeks"))[indexs];
      duringTime = "上午";
    } else if (this.$route.query.index < 14 && this.$route.query.index >= 7) {
      index = JSON.parse(localStorage.getItem("weeks"))[indexs - 7];
      duringTime = "下午";
    } else {
      index = JSON.parse(localStorage.getItem("weeks"))[indexs - 14];
      duringTime = "晚上";
    }
    console.log(index, "============");
    this.currentSelectTime =
      index.dateName + " 周" + index.weekName + " " + duringTime;
  },
  methods: {
     confirmStartTime(value) {
      this.startMeettime = value;
      this.showStartTimes = false;
    },
    confirmEndTime(value) {
      this.endMeettime = value;
      this.showEndTimes = false;
    },
    onSubmit(values) {
      console.log("submit", values);
      addAudit({
        auditId: this.$route.query.id,
        personName: this.username, //联系人
        personPhone: this.password, //联系电话
        purpose: this.message,
        startMeettime: this.startMeettime,
        endMeettime: this.endMeettime,
      }).then((res) => {
        // console.log('123')
        this.$router.go(-1);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pages {
  padding: 20px;
}
</style>
